import { Injectable } from '@angular/core';
import { CustomerApplication } from '../../customer-application';
import { CustomerInfo } from '../../customer-info';
import * as Noty from 'noty';

@Injectable()
export class SharedDataService {
  customerInfo: CustomerInfo;
  customerApplication: CustomerApplication;
  validationMessages: any;
  portalConfigValuesFromS3: any;
  constructor() { }
  saveCustomerInfo(customerInfo: CustomerInfo) {
    this.customerInfo = customerInfo;
  }
  getCustomerInfo(): CustomerInfo {
    return this.customerInfo;
  }

  saveCustomerApplication(customerApplication: CustomerApplication): void {
    this.customerApplication = customerApplication;
  }
  getCustomerApplication(): CustomerApplication {
    return this.customerApplication;
  }

  showError(errorMsg: string) {
    new Noty({
      type: 'error',
      layout: 'center',
      theme: 'metroui',
      text: errorMsg,
      killer: true,
      timeout: 5000,
      progressBar: true
    }).show();
  }

  saveValidationMessages(validationMessages: any) {
    this.validationMessages = validationMessages;
  }
  getValidationMessages(): any {
    return this.validationMessages;
  }

  savePortalConfigValuesFromS3(portalConfigValuesFromS3: any) {
    this.portalConfigValuesFromS3 = portalConfigValuesFromS3;
  }
  getPortalConfigValuesFromS3(): any {
    return this.portalConfigValuesFromS3;
  }
}
